module.exports = __webpack_public_path__ + "static/media/take-away-icon.c7053412.png";